import { render, staticRenderFns } from "./addpayLang.vue?vue&type=template&id=89c393ca&"
import script from "./addpayLang.vue?vue&type=script&lang=js&"
export * from "./addpayLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89c393ca')) {
      api.createRecord('89c393ca', component.options)
    } else {
      api.reload('89c393ca', component.options)
    }
    module.hot.accept("./addpayLang.vue?vue&type=template&id=89c393ca&", function () {
      api.rerender('89c393ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addpayLang.vue"
export default component.exports